<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{title}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <div class="card card-toolbar">
    <div class="card-body">
      <div class="row align-items-center">
        <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2">
          <app-report-type-select translatekey="smsLogReportType"
            [values]="[smsLogReportTypeEnum.ALL, smsLogReportTypeEnum.PENDING, smsLogReportTypeEnum.DELIVERED, smsLogReportTypeEnum.NOT_DELIVERED]" [selected]="reportType"
            (valueChange)="changedReportType($event)">
          </app-report-type-select>
        </div>
        <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
          <app-date-range-select [startDate]="searchCriteria.startDate" [endDate]="searchCriteria.endDate" [dateRange]="'thisyear'" [dateTitle]="dateTitle" (valueChange)="changedDate($event)">
          </app-date-range-select>
        </div>
        <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
          <div class="form-group mb-0">
            <label class="custom-form-label" for="messageTypeInput">{{'sms.messageType' | translate}}</label>
            <select id="messageTypeInput" class="form-control" [(ngModel)]="messageType" (ngModelChange)="getReport()">
              <option value="">{{'common.all' | translate}}</option>
              <option *ngFor="let item of smsMessageTypeEnumValues" [ngValue]="item">{{ 'smsMessageTypeValue.'+item | translate}}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2" *ngIf="stores.length>1">
          <div class="form-group mb-0">
            <label class="custom-form-label" for="storeInput">{{'store.storeName' | translate}}</label>
            <ng-multiselect-dropdown class="custom-multi-select" [settings]="storeDropdownSettings" [data]="stores" [(ngModel)]="selectedStores">
            </ng-multiselect-dropdown>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-2 col-xl-2 d-flex gap-2 align-items-center">
          <input class="form-control flex-grow-1" type="text" name="search" [(ngModel)]="searchText" placeholder="{{'hint.search-in-result' | translate}}" appUppercase autocompleteOff>
          <app-modify-column-widget [screenCode]="screenCode" [cols]="cols" [reportType]="reportType" (valueChange)="setSelectedColumns()"></app-modify-column-widget>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 col-lg-9">
      <div class="card">
        <div class="card-body">
          <p-table #dt [loading]="loading" [columns]="selectedColumns" [value]="dataList| searchGlobal: searchText" selectionMode="single" [(selection)]="selectedData" sortField="id" sortOrder="-1"
            [responsive]="true" [paginator]="true" [rows]="10" [resizableColumns]="false" [reorderableColumns]="true" [exportFilename]="'sms_log'" [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[5,10,15,25,50,100]" currentPageReportTemplate="{first} - {last} of {totalRecords}">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" pResizableColumn pReorderableColumn>
                  <app-table-headers-generic [col]="col"></app-table-headers-generic>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
              <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex" (dblclick)="onRowDblClick($event, rowData)">
                <hr class="d-sm-none solid">
                <td *ngFor="let col of columns">
                  <app-table-columns-generic [data]="rowData[col.field]" [format]="col"></app-table-columns-generic>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer" let-columns>
              <tr>
                <td *ngFor="let col of columns">
                  <app-table-footer-columns-generic [dataList]="dataList" [col]="col"></app-table-footer-columns-generic>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-lg-3">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{{'title.summary' | translate}}</h5>
          <p-table [value]="dataListSummary" sortField="count" sortOrder="-1">
            <ng-template pTemplate="header">
              <tr>
                <th>{{'sms.status' | translate}}</th>
                <th class="text-end">{{'common.count' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td><app-sms-status-badge [value]="row.senderState"></app-sms-status-badge></td>
                <td class="text-end">{{row.count| thousandSeparator}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{{'sms.message' | translate}}</h5>
          <p class="mb-0 small">{{selectedData?.message}}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <span class="badge bg-danger align-self-center me-2" *ngIf="storeSetting?.smsChannelType">{{'sms.smsBalance' | translate}}: {{smsBalance}}</span>

  <button type="button" class="btn btn-secondary" (click)="close()">
    {{'button.close' | translate}}
  </button>

  <div class="d-inline-flex align-items-center gap-1" role="group" aria-label="export">
    <button type="button" class="btn btn-outline-success btn-sm" (click)="exportFile(exportFileTypeEnum.EXCEL)" triggers="mouseenter:mouseleave" placement="top" container="body" [ngbPopover]="'button.export-to-excel'| translate">
    <i class="fa fas fa-file-excel" aria-hidden="true"></i>
  </button>
    <button type="button" class="btn btn-outline-danger btn-sm" (click)="exportFile(exportFileTypeEnum.PDF)" triggers="mouseenter:mouseleave" placement="top" container="body" [ngbPopover]="'button.export-to-pdf'| translate">
    <i class="fa fas fa-file-pdf" aria-hidden="true"></i>
  </button>
  </div>

  <button type="button" class="btn btn-outline-primary" (click)="updateSmsStatus()" [disabled]="isBusy">
    <i class="fa fas fa-edit" aria-hidden="true"></i>
    {{ isBusy ? ('progress.please-wait' | translate) : ('button.update-sms-state' | translate) }}
  </button>
  <button type="button" class="btn btn-success" (click)="goToSendSms()">
    <i class="fas fa-paper-plane" aria-hidden="true"></i>
    {{ 'button.send-sms' | translate }}
  </button>
  <button type="button" class="btn btn-primary" (click)="getReport()">
    <i class="fa fas fa-sync-alt" aria-hidden="true"></i>
    {{ 'button.refresh' | translate}}
  </button>
</div>